import {IWrapper} from '../types';
import {IAuth, Auth, Validate, Logout} from '../types/endpoints';

/**
 * Authentication related endpoints manager
 */
class Authenticate implements IAuth {
  readonly wrapper: IWrapper;

  /**
   * Constructor
   * @param {IWrapper} wrapper - The wrapper instance.
   */
  constructor(wrapper: IWrapper) {
    this.wrapper = wrapper;
  }

  /**
   * Authenticate the user
   */
  public authenticate(username: string): Promise<Auth> {
    return this.wrapper.post<Auth>('/v2/auth/login', {username});
  }

  /**
   * Validate the one-time password
   */
  public validateOtp(username: string, otp: string): Promise<Validate> {
    return this.wrapper.post<Validate>('/v2/auth/validate-otp', {
      username,
      otp,
    });
  }

  /**
   * Logout user
   */
  public logout(): Promise<Logout> {
    return this.wrapper.post<Logout>('/v2/auth/logout', {});
  }
}

export default Authenticate;
